import React from 'react';
import DF from 'DisplayFramework';
import { Tabs } from 'antd';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { Line } from '@ant-design/plots';
import { isNil } from 'lodash';
import { toCurrency, toRate } from 'utils/utils';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { AssetFutureValueScheduleResponse } from 'services/assets';

export type AssetFVscheduleTableProps = {
  assetfvschedule: AssetFutureValueScheduleResponse[];
  currcode: string;
};
const { TabPane } = Tabs;

const AssetFVscheduleTable = (props: AssetFVscheduleTableProps) => {
  const { assetfvschedule, currcode } = props;

  const config = {
    data: assetfvschedule
      .map((irv: any) => ({
        fvdate: irv.fvdate,
        irvtype: 'fvamount',
        amount: Number(irv.fvamount?.toFixed(0)),
      }))
      .concat(
        assetfvschedule.map((irv: any) => ({
          fvdate: irv.fvdate,
          irvtype: 'finrvamount',
          amount: Number(irv.finrvamount?.toFixed(0)),
        }))
      ),
    xField: 'fvdate',
    yField: 'amount',
    seriesField: 'irvtype',
    xAxis: {
      type: 'time',
    },
    yAxis: {
      label: {
        formatter: (v: any) => toCurrency(v, localStorage.getItem('currcode') ?? ''),
      },
    },
  };
  const COLUMNS: DataGridColDef<AssetFutureValueScheduleResponse>[] = [
    {
      comcode: 'fvdate',
      dataIndex: 'fvdate',
      fixed: 'left',
      width: 80,
    },

    {
      comcode: 'fvamount',
      dataIndex: 'fvamount',
      render: (val) => toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),

      fixed: 'left',
      width: 100,
    },

    {
      align: 'right',
      comcode: 'fvpercentage',
      dataIndex: 'fvpercentage',
      render: toRate,
      width: 100,
    },

    {
      align: 'right',
      comcode: 'finrvamount',
      dataIndex: 'finrvamount',
      render: (val) => toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
    },

    {
      comcode: 'fvstatus',
      dataIndex: 'fvstatus',
      fixed: 'left',
      width: 120,
    },
  ];

  return (
    <DF.Provider pagcode="assetfvschedule">
      <Tabs defaultActiveKey="1" animated>
        <TabPane tab={<GetLabel label="Table" />} key="1">
          <DataGrid
            dataSource={assetfvschedule}
            columns={COLUMNS}
            rowKey={(record: any) => record.fvid}
            scroll={{ x: 1000, y: 360 }}
            pagination={{ pageSize: 200 }}
          />
        </TabPane>
        <TabPane tab={<GetLabel label="Charts" />} key="2">
          {!isNil(assetfvschedule) && <Line {...config} />}
        </TabPane>
      </Tabs>
    </DF.Provider>
  );
};

export default AssetFVscheduleTable;
